export const round2 = (macro: number) => {
  return Math.round(macro * 1e2) / 1e2;
};
